import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getPostsStatus, getPostsError } from '@store/reducers/blog/selectors';
import { getBlog, createPost } from '@store/actions/blog';
import { getPermittedPermissions } from '@store/reducers/check-permission/selectors';
import Main from './Main';

const mapStateToProps = state => ({
  status: getPostsStatus(state),
  permittedPermissions: getPermittedPermissions(state),
  errors: getPostsError(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getBlog,
      createPost,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
